'use strict';

import Config from './config';

export default class Store {

    static save(data) {
        localStorage.setItem('__DomoticalabsConfig', JSON.stringify(data));
    }

    static getData() {
        return JSON.parse(localStorage.getItem('__DomoticalabsConfig'));
    }

    static exists() {
        let status = false;

        if (localStorage.getItem('__DomoticalabsConfig') !== null) {
            status = true;
        }
        return status;
    }

    static destroy() {
        localStorage.removeItem('__DomoticalabsConfig');
    }

    static things(data) {
        localStorage.setItem('__DomoticalabsThings', JSON.stringify(data));
    }

    static getThings() {
        return JSON.parse(localStorage.getItem('__DomoticalabsThings'));
    }

}



// WEBPACK FOOTER //
// ./src/store.js